export const GENERAL_DOCUMENT_TYPE = 1; 
export const DOC2SIGN_DOCUMENT_TYPE = 2;
export const CFDI = 3;
export const CFDI_MASIVO = 4;
export const CEDULA_FISCAL = 5;
export const SUA = 6;
export const PERSONA_MORAL = 7;
export const PERSONA_FISICA = 8;
export const SIMPLIFICADO_DE_CONFIANZA = 9;
export const REGION_FRONTERIZA = 10;
export const ISR = 11;
export const SAT = 12;
export const REPSE = 13;
export const IMSS = 14;
export const INFONAVIT = 15;

export const GENERAL_CATEGORY = 1;
export const AUTOMATIC_CATEGORY = 2;
export const CFDI_CATEGORY = 3;
export const DOC2SIGN_CATEGORY = 4;

